export default {
    logout: 'ลงชื่อออก',
    msgConfirm: 'คุณแน่ใจที่จะลงชื่อออก?',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน'
}
